<template>
  <div id="sportsbook-container">
    <v-row>
      <v-col
        class="border-right"
        cols="12"
        md="3"
      >
        <v-autocomplete
          :items="states_option"
          class="custom"
          clearable
          dense
          label="State"
          v-model="states_filter_id"
          @click:clear="clearStateFilter()"
          @input="filterByState"
        ></v-autocomplete>
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <span
          v-if="mode === 'update'"
          class="text-caption delete-sportbook"
          @click="confirmDeleteDialog = true"
        >Delete Sportsbook</span>
        <span
          v-else
          class="text-caption delete-sportbook"
          @click="resetData"
        >Cancel</span>
      </v-col>
      <v-col
        class="text-right"
        cols="12"
        md="1"
        v-if="mode === 'update'"
      >
        <b
          class="text-caption font-weight-bold header-btns"
          @click="previewBook"
        >Preview</b>
      </v-col>
      <v-col
        class="text-right"
        cols="12"
        md="1"
        v-if="mode === 'update'"
      >
        <b
          class="text-caption font-weight-bold header-btns"
          @click="onDuplicateBook"
        >Duplicate</b>
      </v-col>
      <v-col
        cols="12"
        md="2"
        class="text-right"
      >
        <b
          class="text-caption font-weight-bold header-btns"
          @click="saveChanges"
        >Save Changes</b>
      </v-col>
      <v-col
        class="text-right"
        cols="12"
        md="2"
      >
        <v-btn
          @click="publishChanges"
          class="publish-btn"
          color="error lighten-1"
          height="25"
          small
          width="150"
        >{{publish_btn_txt}}</v-btn>
      </v-col>
    </v-row>
    <v-row class="sportsbook-row">
      <v-col
        class="border-right"
        cols="12"
        md="3"
      >
        <div
          class="infinite-loading-row"
          v-infinite-scroll="loadMore"
          infinite-scroll-disabled="loadingMore"
          infinite-scroll-distance="10"
          infinite-scroll-immediate-check
        >
          <v-row
            v-for="(book, index) in this.sportsBooksList"
            :key="index"
            class="booklist-row"
            :class="{'selected-item' : index === activeIndex}"
          >
            <v-row @click="getBookData(book.id, index)">
              <v-col md="4">
                <v-img
                  v-if="book.logo"
                  class="white--text align-end book-image"
                  :src="get(book, 'logo.thumb_url')"
                  width="120"
                  height="100%"
                  contain
                ></v-img>
                <v-img
                  v-else
                  class="white--text align-end book-image"
                  contain
                  width="120"
                  height="100%"
                  :src="require('@/assets/images/no-image.png')"
                ></v-img>
              </v-col>
              <v-col md="8">
                <v-list-item
                  three-line
                  dense
                >
                  <v-list-item-content>
                    <v-list-item-title class="text-h7 text-wrap font-weight-bold">{{ book.name }}
                      <span v-if="book.states.length > 0">(</span>
                      <span
                        v-for="(state, index) in book.states"
                        :key="index"
                      >
                        {{state.name}}
                        <span v-if="book.states.length !== index +1">,</span>
                      </span>
                      <span v-if="book.states.length > 0">)</span>
                    </v-list-item-title>
                    <!-- <v-list-item-subtitle class="article-description">{{ item.description_caption }}</v-list-item-subtitle> -->
                  </v-list-item-content>
                </v-list-item>
              </v-col>
            </v-row>
          </v-row>
          <v-skeleton-loader
            v-if="loadingMore"
            type="list-item"
          />
        </div>
        <v-row>
          <b
            @click="resetData"
            class="text-caption font-weight-bold header-btns add-book-btn"
          >Add new sportsBook</b>
        </v-row>
      </v-col>
      <v-col
        class="border-right"
        cols="12"
        md="7"
      >
        <v-form
          lazy-validation
          ref="form"
        >
          <v-row>
            <v-col
              class="text-center"
              cols="12"
              md="6"
            >
              <v-img
                :src="logo_preview_url"
                class="sportsbook-logo"
                contain
                v-if="logo_preview_url"
              ></v-img>
              <v-img
                :src="require('@/assets/images/sportsbooks/promoHead.png')"
                class="sportsbook-logo"
                contain
                v-else
              ></v-img>
              <input
                @change="onFileChange"
                accept=".jpg, .jpeg, .png"
                ref="file"
                style="display: none"
                type="file"
              />
              <v-btn
                @click="$refs.file.click()"
                block
                class="upload-btn"
                height="25"
                small
              >Regular Logo(Promo Head)</v-btn>
            </v-col>
            <v-col
              class="text-center"
              cols="12"
              md="6"
            >
              <v-img
                :src="welcome_logo_preview_url"
                class="sportsbook-logo"
                contain
                v-if="welcome_logo_preview_url"
              ></v-img>
              <v-img
                :src="require('@/assets/images/sportsbooks/bestBooks.png')"
                class="sportsbook-logo"
                contain
                v-else
              ></v-img>
              <input
                @change="welcomeLogoFileChange"
                accept=".jpg, .jpeg, .png"
                ref="welcomeLogo"
                style="display: none"
                type="file"
              />
              <v-btn
                @click="$refs.welcomeLogo.click()"
                block
                class="upload-btn"
                height="25"
                small
              >Logo for Best Books</v-btn>
            </v-col>
            <v-col
              class="text-center"
              cols="12"
              md="12"
            >
              <v-img
                :src="banner_logo_preview_url"
                class="sportsbook-logo"
                contain
                v-if="banner_logo_preview_url"
              ></v-img>
              <v-img
                :src="require('@/assets/images/sportsbooks/banner.png')"
                class="sportsbook-logo"
                contain
                v-else
              ></v-img>
              <input
                @change="bannerFileChange"
                accept=".jpg, .jpeg, .png"
                ref="bannerLogo"
                style="display: none"
                type="file"
              />
              <v-btn
                @click="$refs.bannerLogo.click()"
                block
                class="upload-btn"
                height="25"
                small
              >Large Banner Image (Bookie Reviews)</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              class="text-center"
              cols="12"
              md="6"
            >
              <v-img
                :src="small_logo_preview_url"
                class="sportsbook-logo-small"
                contain
                v-if="small_logo_preview_url"
              ></v-img>
              <v-img
                :src="require('@/assets/images/sportsbooks/verysmall.png')"
                class="sportsbook-logo-small"
                contain
                v-else
              ></v-img>
              <input
                @change="onSmallLogoChange"
                accept=".jpg, .jpeg, .png"
                ref="xsmallLogo"
                style="display: none"
                type="file"
              />
              <v-btn
                @click="$refs.xsmallLogo.click()"
                block
                class="upload-btn"
                height="25"
                small
              >Small Logo</v-btn>
            </v-col>
            <v-col
              class="text-center"
              cols="12"
              md="6"
            >
              <v-img
                :src="welcome_promo_logo_preview_url"
                class="sportsbook-logo-small"
                contain
                v-if="welcome_promo_logo_preview_url"
              ></v-img>
              <v-img
                :src="require('@/assets/images/no-image.png')"
                class="sportsbook-logo-small"
                contain
                v-else
              ></v-img>
              <input
                @change="onWelcomePromoLogoChange"
                accept=".jpg, .jpeg, .png"
                ref="welcomePromoLogo"
                style="display: none"
                type="file"
              />
              <v-btn
                @click="$refs.welcomePromoLogo.click()"
                block
                class="upload-btn"
                height="25"
                small
              >Welcome Promo Logo</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              class="text-left"
              cols="12"
              md="6"
            >
              <v-text-field
                label="SportsBook name"
                v-model="sportsbook_data.name"
              ></v-text-field>
              <v-text-field
                label="Website URL"
                v-model="sportsbook_data.website_url"
              ></v-text-field>
              <v-text-field
                label="BetHub Code"
                v-model="sportsbook_data.bethub_code"
              ></v-text-field>
              <v-autocomplete
                :items="states_option"
                clearable
                dense
                label="States"
                multiple
                v-model="state_ids"
                @click:clear="clearStateIds()"
              ></v-autocomplete>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <label>Brand Color</label>
              <v-color-picker
                class="mx-auto"
                show-swatches
                v-model="color"
                mode="hexa"
              ></v-color-picker>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="12"
            >
              <span class="section-headers">H1</span>
              <v-textarea
                solo
                v-model="sportsbook_data.content_title"
                hint="Varaibles ${stateName}, ${stateCode} and ${year} can be used here."
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="12"
            >
              <span class="section-headers">Description</span>
              <v-textarea
                solo
                v-model="sportsbook_data.content_description"
                hint="Varaibles ${stateName}, ${stateCode} and ${year} can be used here."
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <span class="section-headers">Why join?</span>
              <v-textarea
                placeholder="description"
                solo
                v-model="sportsbook_data.why_description"
                hint="Varaibles ${stateName}, ${stateCode} and ${year} can be used here."
              ></v-textarea>
              <v-row
                :key="i"
                dense
                v-for="(reason, i) in  sportsbook_data.why_checklist"
              >
                <v-col
                  cols="12"
                  md="11"
                >
                  <v-text-field
                    dense
                    placeholder="Why join?"
                    solo
                    v-model="sportsbook_data.why_checklist[i]"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="1"
                >
                  <v-icon
                    @click="removeReason(i)"
                    class="remove-reason"
                    color="error lighten-1"
                  >mdi-delete</v-icon>
                </v-col>
              </v-row>
              <b
                @click="addReason"
                class="text-caption font-weight-bold header-btns"
                v-if="sportsbook_data.why_checklist.length < 3"
              >Add reason</b>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <span class="section-headers">Call-to-action</span>
              <v-text-field
                dense
                placeholder="Title"
                solo
                v-model="sportsbook_data.cta_title"
                hint="Varaibles ${stateName}, ${stateCode} and ${year} can be used here."
              ></v-text-field>
              <v-row dense>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-text-field
                    dense
                    placeholder="Signup URL"
                    solo
                    v-model="sportsbook_data.cta_url"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row
                :key="i"
                dense
                v-for="(bonus, i) in sportsbook_data.cta_bonuses"
              >
                <v-col
                  cols="12"
                  md="11"
                >
                  <v-text-field
                    dense
                    placeholder="Bonus"
                    solo
                    v-model="sportsbook_data.cta_bonuses[i]"
                  ></v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="1"
                >
                  <v-icon
                    @click="removeBonus(i)"
                    class="remove-reason"
                    color="error lighten-1"
                  >mdi-delete</v-icon>
                </v-col>
              </v-row>
              <b
                @click="addBonus"
                class="text-caption font-weight-bold header-btns"
                v-if="sportsbook_data.cta_bonuses.length < 3"
              >Add Bonus</b>
            </v-col>
          </v-row>
          <!-- <v-row>
            <v-col cols="12" md="6">
              <span class="section-headers">Sportsbook Promos</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col :key="i" cols="12" md="6" v-for="(promos, i) in sportsbook_data.promos">
              <v-card color="grey lighten-3">
                <v-card-text>
                  <v-text-field
                    dense
                    flat
                    label="Promo Title"
                    outlined
                    v-model="sportsbook_data.promos[i]['header']"
                  ></v-text-field>
                  <v-text-field
                    dense
                    flat
                    label="Promo SubTitle"
                    outlined
                    v-model="sportsbook_data.promos[i]['sub_header']"
                  ></v-text-field>
                  <v-text-field
                    dense
                    flat
                    label="Signup URL"
                    outlined
                    v-model="sportsbook_data.promos[i]['affiliate_link']"
                  ></v-text-field> -->
          <!-- <v-text-field
                    label="Match ID"
                    outlined
                    dense
                    flat
                    v-model="sportsbook_data.promos[i]['match_id']"
                  ></v-text-field>-->

          <!-- <v-checkbox
                    label="Best Promo"
                    v-model="sportsbook_data.promos[i]['best_promo_flag']"
                  ></v-checkbox>
                  <v-text-field
                    label="Best Promo Priority"
                    outlined
                    v-if="sportsbook_data.promos[i]['best_promo_flag']"
                    v-model="sportsbook_data.promos[i]['best_promo_position']"
                  ></v-text-field>
                  <v-checkbox
                    label="Welcome Promo"
                    v-model="sportsbook_data.promos[i]['welcome_promo_flag']"
                  ></v-checkbox>
                  <v-text-field
                    label="Welcome Promo Priority"
                    outlined
                    v-if="sportsbook_data.promos[i]['welcome_promo_flag']"
                    v-model="sportsbook_data.promos[i]['welcome_promo_position']"
                  ></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <b
                    @click="removePromo(i)"
                    class="text-caption font-weight-bold header-btns"
                  >Remove Promo</b>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <b @click="addPromo" class="text-caption font-weight-bold header-btns">Add Promo</b>
            </v-col>
          </v-row> -->
          <v-row>
            <v-col
              cols="12"
              md="12"
            >
              <span class="section-headers">Default Promo Disclaimer</span>
              <v-textarea
                solo
                v-model="sportsbook_data.disclaimer_text"
                hint="A default disclaimer will be used if none provided. Varaibles ${stateName}, ${stateCode} and ${year} can be used here."
              ></v-textarea>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <span class="section-headers">CTA Button Text</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                dense
                label="CTA Button Text"
                solo
                v-model="sportsbook_data.cta_btn_text"
                hint="This will be used on all CTA buttons for this SportsBook."
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <span class="section-headers">Sportsbook Review</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                label="Author"
                v-model="sportsbook_data.review_author_name"
              ></v-text-field>
            </v-col>
            <v-col
              class="text-center"
              cols="12"
              md="6"
            >
              <v-select
                v-model="sportsbook_data.review_publish_status"
                :items="publish_status_options"
                label="Review status"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="sportsbook_data.review_rating"
                type="number"
                clearable
                :rules="[ ratingRules ]"
                dense
                label="Review Rating"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              class="text-center"
              cols="12"
              md="6"
            >
              <v-img
                :src="review_author_avatar_preview"
                class="sportsbook-logo"
                contain
                v-if="review_author_avatar_preview"
              ></v-img>
              <v-img
                :src="require('@/assets/images/no-image.png')"
                class="sportsbook-logo"
                contain
                v-else
              ></v-img>
              <input
                @change="onChangeAvatar"
                accept=".jpg, .jpeg, .png"
                ref="authorAvatar"
                style="display: none"
                type="file"
              />
              <v-btn
                @click="$refs.authorAvatar.click()"
                block
                class="upload-btn"
                height="25"
                small
              >Author avatar</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="12"
              sm="12"
            >
              <h4>Review Content</h4>
              <small class="text-captopn grey--text">Varaibles ${stateName}, ${stateCode} and ${year} can be used here.</small>
              <editor
                :init="init"
                api-key="owh5wfefwxc6ww1ieij5ne4rtzan6ycdfjtvpjhap6zv86zs"
                v-model="sportsbook_data.review_description"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-card color="grey lighten-3">
                <v-card-title class="pros">Pros</v-card-title>
                <v-card-text>
                  <v-row
                    :key="i"
                    v-for="(pro, i) in sportsbook_data.review_pros"
                  >
                    <v-col
                      cols="12"
                      md="10"
                    >
                      <v-text-field
                        dense
                        flat
                        solo
                        v-model="sportsbook_data.review_pros[i]"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="1"
                    >
                      <v-icon
                        @click="removePros(i)"
                        class="remove-reason"
                        color="error lighten-1"
                      >mdi-delete</v-icon>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <b
                    @click="addPros"
                    class="text-caption font-weight-bold header-btns"
                    v-if="sportsbook_data.review_pros.length < 3"
                  >Add item</b>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-card color="grey lighten-3">
                <v-card-title class="cons">Cons</v-card-title>
                <v-card-text>
                  <v-row
                    :key="i"
                    v-for="(pro, i) in sportsbook_data.review_cons"
                  >
                    <v-col
                      cols="12"
                      md="10"
                    >
                      <v-text-field
                        dense
                        flat
                        solo
                        v-model="sportsbook_data.review_cons[i]"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="1"
                    >
                      <v-icon
                        @click="removeCons(i)"
                        class="remove-reason"
                        color="error lighten-1"
                      >mdi-delete</v-icon>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <b
                    @click="addCons"
                    class="text-caption font-weight-bold header-btns"
                    v-if="sportsbook_data.review_cons.length < 3"
                  >Add item</b>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <span class="section-headers">Sportsbook Services</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <v-card color="grey lighten-3">
                <v-card-title>Sports</v-card-title>
                <v-card-text>
                  <v-row
                    :key="i"
                    v-for="(sport, i) in services_sports"
                  >
                    <v-col
                      cols="12"
                      md="10"
                    >
                      <v-text-field
                        dense
                        flat
                        solo
                        v-model="services_sports[i]['category_details']"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="1"
                    >
                      <v-icon
                        @click="removeSport(i)"
                        class="remove-reason"
                        color="error lighten-1"
                      >mdi-delete</v-icon>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <b
                    @click="addSport"
                    class="text-caption font-weight-bold header-btns"
                  >Add item</b>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-card color="grey lighten-3">
                <v-card-title>Deposit</v-card-title>
                <v-card-text>
                  <v-row
                    :key="i"
                    v-for="(deposit, i) in deposit_options"
                  >
                    <v-col
                      cols="12"
                      md="10"
                    >
                      <v-text-field
                        dense
                        flat
                        solo
                        v-model="deposit_options[i]['category_details']"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="1"
                    >
                      <v-icon
                        @click="removeDepositOption(i)"
                        class="remove-reason"
                        color="error lighten-1"
                      >mdi-delete</v-icon>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <b
                    @click="addDepositOption"
                    class="text-caption font-weight-bold header-btns"
                  >Add item</b>
                </v-card-actions>
              </v-card>

              <v-card
                class="withdrawal-options"
                color="grey lighten-3"
              >
                <v-card-title>Withdrawal Options</v-card-title>
                <v-card-text>
                  <v-row
                    :key="i"
                    v-for="(withdrawal_option, i) in withdrawal_options"
                  >
                    <v-col
                      cols="12"
                      md="10"
                    >
                      <v-text-field
                        dense
                        flat
                        solo
                        v-model="withdrawal_options[i]['category_details']"
                      ></v-text-field>
                    </v-col>
                    <v-col
                      cols="12"
                      md="1"
                    >
                      <v-icon
                        @click="removeWithdrawalOption(i)"
                        class="remove-reason"
                        color="error lighten-1"
                      >mdi-delete</v-icon>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <b
                    @click="addWithdrawalOption"
                    class="text-caption font-weight-bold header-btns"
                  >Add item</b>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              md="6"
            >
              <span class="section-headers">FAQs</span>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              :key="i"
              cols="12"
              md="12"
              v-for="(faq, i) in sportsbook_data.faqs"
            >
              <v-card
                class="withdrawal-options"
                color="grey lighten-3"
              >
                <v-card-text>
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <v-text-field
                        dense
                        flat
                        placeholder="Question"
                        solo
                        v-model="sportsbook_data.faqs[i].question"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                    >
                      <editor
                        :init="init"
                        api-key="owh5wfefwxc6ww1ieij5ne4rtzan6ycdfjtvpjhap6zv86zs"
                        v-model="sportsbook_data.faqs[i].answer"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <b
                    @click="removeFAQ(i)"
                    class="text-caption font-weight-bold header-btns"
                  >remove</b>
                </v-card-actions>
              </v-card>
            </v-col>
            <v-col
              cols="12"
              md="12"
            >
              <b
                @click="addFAQ"
                class="text-caption font-weight-bold header-btns"
              >Add FAQ</b>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
      <v-col
        cols="12"
        md="2"
      >
        <v-row>
          <v-col
            md="12"
            cols="12"
          >
            <span class="text-title">Page Settings</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            md="12"
            cols="12"
          >
            <span class="text-caption font-weight-bold">URL options</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="12"
          >
            <v-text-field
              label="url slug"
              v-model="sportsbook_data.slug"
            ></v-text-field>
            <v-btn
              v-if="sportsbook_data.name"
              x-small
              color="success"
              @click="triggerGenerateSlug"
            >
              <pulse-loader v-if="generatingSlug"></pulse-loader>
              <span v-else>generate slug</span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            md="12"
            cols="12"
          >
            <span class="text-caption font-weight-bold">Meta tags</span>
          </v-col>
        </v-row>
        <v-spacer></v-spacer>
        <v-row>
          <v-col
            cols="12"
            sm="12"
            md="12"
          >
            <v-text-field
              hint="There is no limit on the number of characters, but it’s best to stay between 60 and 90. If your title is longer than 100 characters, Facebook will truncate it to only 88!"
              label="Title"
              v-model="sportsbook_data.title_meta"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            sm="12"
            md="12"
          >
            <v-textarea
              hint="Keep it short and sweet. Facebook recommends 2–4 sentences, but that often truncates."
              label="Description"
              v-model="sportsbook_data.description_meta"
              solo
              counter="500"
            ></v-textarea>
          </v-col>
          <v-col
            class="text-center"
            cols="12"
            md="12"
          >
            <v-img
              :src="image_meta_preview_url"
              class="sportsbook-logo"
              contain
              v-if="image_meta_preview_url"
            ></v-img>
            <v-img
              :src="require('@/assets/images/no-image.png')"
              class="sportsbook-logo"
              contain
              v-else
            ></v-img>
            <input
              @change="imageMetaFileChange"
              accept=".jpg, .jpeg, .png"
              ref="imageMeta"
              style="display: none"
              type="file"
            />
            <v-btn
              @click="$refs.imageMeta.click()"
              block
              class="upload-btn"
              height="25"
              small
            >Image</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            class="mt-10"
            md="12"
            cols="12"
          >
            <span class="text-caption font-weight-bold">Review Schema</span>
          </v-col>

          <v-col
            cols="12"
            md="12"
          >
            <v-text-field
              label="Name"
              v-model="sportsbook_data.review_schema_name"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-text-field
              v-model="sportsbook_data.review_schema_review"
              type="number"
              clearable
              :rules="[ ratingRules ]"
              label="Rating"
            ></v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-textarea
              label="Description"
              v-model="sportsbook_data.review_schema_description"
              hint="Varaibles ${stateName}, ${stateCode} and ${year} can be used here."
            ></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            class="mt-10"
            md="12"
            cols="12"
          >
            <span class="text-caption font-weight-bold">Image Alt Text</span>
          </v-col>
          <v-col
            cols="12"
            md="12"
          >
            <v-text-field
              label="image alt text"
              v-model="sportsbook_data.image_alt_text"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog
        v-model="validation_dialog"
        width="500"
        scrollable
      >
        <v-card>
          <v-card-title class="headline grey lighten-2">Validation Errors</v-card-title>

          <v-card-text>
            <v-row
              v-for="(error, i) in validation_errors"
              :key="i"
            >
              <v-col
                cols="12"
                md="12"
              >
                <span class="header-btns">*{{ error }}</span>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="validation_dialog = false"
            >Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <v-overlay
      absolute
      :value="loading"
    >
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            {{ loading_message }}
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
    <v-snackbar
      v-model="snackbar.show"
      right
      :color="snackbar.color"
    >
      {{ snackbar.message }}
      <v-btn
        text
        @click="snackbar.show = false"
      >OK</v-btn>
    </v-snackbar>
    <v-dialog
      v-model="confirmDeleteDialog"
      persistent
      max-width="360"
    >
      <v-card>
        <v-card-title class="headline">
          <p class="confirm-delete">Are you sure you want to delete this SportsBook?</p>
        </v-card-title>
        <v-card-text>Delete SportsBook.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            text
            @click="confirmDeleteDialog = false"
          >No</v-btn>
          <v-btn
            color="red darken-1 white--text"
            @click="triggerDeleteSportsBook()"
          >Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import editorConfig from '@/utils/articles/editor-config'
import { find, each } from 'lodash'
import infiniteScroll from 'vue-infinite-scroll'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import get from 'lodash/get'

export default {
  name: 'SportsBooksPage',

  data () {
    return {
      previewDialog: false,
      creation_mode: 'save',
      generatingSlug: false,
      confirmDeleteDialog: false,
      publish_btn_txt: 'Publish',
      loadingMore: false,
      activeIndex: null,
      loading: false,
      loading_message: 'Fetching SportsBooks',
      mode: 'create',
      validation_dialog: false,
      init: editorConfig,
      states_option: [],
      states_filter_id: '',
      location_filter: '',
      state_ids: [],
      logo_preview_url: '',
      small_logo_preview_url: '',
      welcome_promo_logo_preview_url: '',
      banner_logo_preview_url: '',
      welcome_logo_preview_url: '',
      image_meta_preview_url: '',
      review_author_avatar_preview: '',
      sportsbook_data: {
        slug: '',
        name: '',
        content_description: '',
        website_url: '',
        bethub_code: '',
        states: [],
        why_description: '',
        why_checklist: [],
        hex_color: '',
        promos: [],
        review_author_name: '',
        review_description: '',
        review_rating: '',
        review_pros: [],
        review_cons: [],
        review_publish_status: 'draft',
        review_avatar: null,
        services: [],
        faqs: [],
        logo: null,
        banner_logo: null,
        welcome_logo: null,
        small_logo: null,
        welcome_promo_logo: null,
        publish_status: '',
        cta_title: '',
        cta_bonuses: [],
        cta_url: '',
        image_meta: null,
        title_meta: '',
        description_meta: '',
        cta_btn_text: '',
        disclaimer_text: '',
        review_schema_name: '',
        review_schema_review: '',
        review_schema_description: '',
        image_alt_text: '',
        content_title: ''
      },
      services_sports: [],
      deposit_options: [],
      withdrawal_options: [],
      rules: {
        required: [
          v => !!v || 'this field is required'
        ]
      },
      validation_errors: [],
      publish_status_options: ['draft', 'published'],
      snackbar: {
        show: false,
        message: null,
        color: 'success'
      },
      selected_book_id: null,
      selected_book_data: '',
      type: 'hex',
      hex: '#FFFFFF'

    }
  },

  directives: {
    infiniteScroll
  },

  components: {
    PulseLoader
  },

  computed: {
    ...mapState({
      usStates: state => state.usStates.list,
      requestStatus: state => state.bookmaker.requestStatus,
      requestMsg: state => state.bookmaker.requestMsg,
      sportsBooksList: state => state.bookmaker.list,
      listMeta: state => state.bookmaker.listMeta
    }),

    color: {
      get () {
        return this[this.type]
      },
      set (v) {
        this[this.type] = v
      }
    }
  },

  methods: {
    get,
    ...mapActions({
      getStates: 'usStates/getStates',
      createSportBook: 'bookmaker/createSportsBook',
      getBookList: 'bookmaker/getBookList',
      getBookMaker: 'bookmaker/getBookMaker',
      updateSportBook: 'bookmaker/updateSportBook',
      deleteSportsBook: 'bookmaker/deleteSportsBook',
      duplicateSportsBook: 'bookmaker/duplicateSportsBook',
      updateBookLogo: 'bookmaker/updateBookLogo',
      deleteBookLogo: 'bookmaker/deleteBookLogo',
      updateBookBanner: 'bookmaker/updateBookBanner',
      deleteBookBanner: 'bookmaker/deleteBookBanner',
      updateBookWelcomeImage: 'bookmaker/updateBookWelcomeImage',
      deleteBookWelcomeImage: 'bookmaker/deleteBookWelcomeImage',
      refreshList: 'bookmaker/refreshList',
      updateReviewAvatar: 'bookmaker/updateReviewAvatar',
      deleteReviewAvatar: 'bookmaker/deleteReviewAvatar',
      generateSlug: 'article/generateArticleSlug',
      updateImageMeta: 'bookmaker/updateImageMeta',
      deleteImageMeta: 'bookmaker/deleteImageMeta',
      updateSmallLogo: 'bookmaker/updateSmallLogo',
      updateWelcomePromoLogo: 'bookmaker/updateWelcomePromoLogo',
    }),

    async fetchUSStates (page = 1) {
      let params = { page }
      await this.getStates(params)
      let states = this.usStates

      states.forEach((value, key, map) => {
        this.states_option.push({
          text: value.name,
          value: value.id
        })
      })
    },

    async fetchSportsBookList (page = 1) {
      let params = { page }

      params.sort = '-created_at'
      this.loading = true
      await this.getBookList(params)
      this.loading = false
    },
    onFileChange (e) {
      const file = e.target.files[0]
      this.logo_preview_url = URL.createObjectURL(file)
      this.sportsbook_data.logo = file
    },

    onSmallLogoChange (e) {
      const file = e.target.files[0]
      this.small_logo_preview_url = URL.createObjectURL(file)
      this.sportsbook_data.small_logo = file
    },

    onWelcomePromoLogoChange (e) {
      const file = e.target.files[0]
      this.welcome_promo_logo_preview_url = URL.createObjectURL(file)
      this.sportsbook_data.welcome_promo_logo = file
    },

    bannerFileChange (e) {
      const file = e.target.files[0]
      this.banner_logo_preview_url = URL.createObjectURL(file)
      this.sportsbook_data.banner_logo = file
    },

    onChangeAvatar (e) {
      const file = e.target.files[0]
      this.review_author_avatar_preview = URL.createObjectURL(file)
      this.sportsbook_data.review_avatar = file
    },

    welcomeLogoFileChange (e) {
      const file = e.target.files[0]
      this.welcome_logo_preview_url = URL.createObjectURL(file)
      this.sportsbook_data.welcome_logo = file
    },

    imageMetaFileChange (e) {
      const file = e.target.files[0]
      this.image_meta_preview_url = URL.createObjectURL(file)
      this.sportsbook_data.image_meta = file
    },

    addReason () {
      this.sportsbook_data.why_checklist.push('')
    },

    removeReason (i) {
      this.sportsbook_data.why_checklist.splice(i, 1)
    },

    addBonus () {
      this.sportsbook_data.cta_bonuses.push('')
    },

    removeBonus (i) {
      this.sportsbook_data.cta_bonuses.splice(i, 1)
    },

    addPromo () {
      this.sportsbook_data.promos.push({
        header: '',
        sub_header: '',
        affiliate_link: '',
        best_promo_flag: false,
        welcome_promo_flag: false,
        best_promo_position: '',
        welcome_promo_position: '',
        match_id: ''
      })
    },

    removePromo (i) {
      this.sportsbook_data.promos.splice(i, 1)
    },

    addPros () {
      this.sportsbook_data.review_pros.push('')
    },

    addCons () {
      this.sportsbook_data.review_cons.push('')
    },

    removePros (i) {
      this.sportsbook_data.review_pros.splice(i, 1)
    },

    removeCons (i) {
      this.sportsbook_data.review_cons.splice(i, 1)
    },

    addSport () {
      this.services_sports.push({
        category: 'Sports',
        category_details: ''
      })
    },

    removeSport (i) {
      this.services_sports.splice(i, 1)
    },

    addDepositOption () {
      this.deposit_options.push({
        category: 'Deposit',
        category_details: ''
      })
    },

    removeDepositOption (i) {
      this.deposit_options.splice(i, 1)
    },

    addWithdrawalOption () {
      this.withdrawal_options.push({
        category: 'Withdrawal Options',
        category_details: ''
      })
    },

    removeWithdrawalOption (i) {
      this.withdrawal_options.splice(i, 1)
    },

    addFAQ () {
      this.sportsbook_data.faqs.push(
        {
          question: '',
          answer: ''
        }
      )
    },

    removeFAQ (i) {
      this.sportsbook_data.faqs.splice(i, 1)
    },

    async saveSportBook () {

    },

    validateForm () {
      this.loading = true
      this.customValidation()

      if (this.validation_errors.length > 0) {
        this.loading = false
        this.validation_dialog = true
        return false
      }
      if (this.$refs.form.validate() && this.validation_errors.length === 0) {
        return true
      } else {
        this.loading = false
        this.validation_dialog = true
        return false
      }
    },

    customValidation () {
      let data = this.sportsbook_data

      // if (!data.name) {
      //   this.validation_errors.push('SportBook name is required.')
      // }

      // if (!data.content_description) {
      //   this.validation_errors.push('Sportbook description is required.')
      // }
      // if (this.mode === 'create') {
      //   if (!data.logo) {
      //     this.validation_errors.push('Regular logo is required.')
      //   }

      //   if (!data.banner_logo) {
      //     this.validation_errors.push('Banner image is required.')
      //   }

      //   if (!data.welcome_logo) {
      //     this.validation_errors.push('Small logo is required.')
      //   }
      // }

      this.sportsbook_data.why_checklist = data.why_checklist.filter(item => item)

      this.sportsbook_data.cta_bonuses = data.cta_bonuses.filter(item => item)

      if (data.cta_title && data.cta_bonuses.length === 0) {
        this.validation_errors.push('Provide at least 1 CTA bonus.')
      }

      let promoHeaderError = false
      let promoSubHeaderError = false
      each(data.promos, (promo, i) => {
        if (!promo.header && !promo.sub_header) {
          this.removePromo(i)
        } else {
          if (!promo.header) {
            promoHeaderError = true
          }

          if (!promo.sub_header) {
            promoSubHeaderError = true
          }
        }
      })

      if (promoHeaderError === true) {
        this.validation_errors.push('Promo title is required')
      }

      if (promoSubHeaderError === true) {
        this.validation_errors.push('Promo Subtitle is required')
      }

      let faqQError = false
      let faqAError = false

      each(data.faqs, (faq, i) => {
        if (!faq.question && !faq.answer) {
          this.removeFAQ(i)
        } else {
          if (!faq.question) {
            faqQError = true
          }

          if (!faq.answer) {
            faqAError = true
          }
        }
      })

      if (faqQError === true) {
        this.validation_errors.push('FAQ question is required')
      }

      if (faqAError === true) {
        this.validation_errors.push('FAQ answer is required')
      }

      if (data.review_author_name) {
        if (!data.review_description) {
          this.validation_errors.push('Review content is required')
        }

        if (!data.review_rating) {
          this.validation_errors.push('Review rating is required')
        } else {
          if (data.review_rating > 5) {
            this.validation_errors.push('Max review rating is 5')
          }

          if (data.review_rating < 1) {
            this.validation_errors.push('Min review rating is 1')
          }
        }

        if (data.review_pros.length === 0) {
          this.validation_errors.push('Provide at leat 1 item for Review pros')
        }

        if (data.review_cons.length === 0) {
          this.validation_errors.push('Provide at leat 1 item for Review cons')
        }

        if (!data.review_avatar && this.mode === 'create') {
          this.validation_errors.push('Review author avatar is required')
        }
      }

      this.services_sports = this.services_sports.filter(function (service) {
        if (service.category_details) return service
      })

      this.deposit_options = this.deposit_options.filter(function (service) {
        if (service.category_details) return service
      })

      this.withdrawal_options = this.withdrawal_options.filter(function (service) {
        if (service.category_details) return service
      })

      // this.sportsbook_data.services = [...this.services_sports, ...this.deposit_options, ...this.withdrawal_options]
    },

    clearValidationErrors () {
      this.validation_dialog = false
      this.validation_errors = []
    },

    ratingRules (val) {
      if (val) {
        if (val > 5) {
          return 'Max rating is 5'
        } else if (val < 1) {
          return 'Min rating is 1'
        } else {
          return true
        }
      } else {
        return true
      }
    },

    colorPickerRules (val) {
      if (val) {
        if (val > 5) {
          return 'Max H is 5'
        } else {
          return true
        }
      } else {
        return true
      }
    },

    promoOrderOnChange (i) {
      each(this.sportsbook_data.promos, (promos, index) => {
        if (index !== i && promos.best_promo_position === this.sportsbook_data.promos[i]['best_promo_position']) {
          this.sportsbook_data.promos[index]['best_promo_position'] = null
        }
      })
    },

    saveChanges () {
      this.creation_mode = 'save'
      if (this.validateForm()) {
        if (this.mode === 'create') {
          this.loading_message = 'Creating Sportsbook'
          this.sportsbook_data.publish_status = 'draft'
          this.triggerCreateSportsBook()
        } else if (this.mode === 'update') {
          this.loading_message = 'Updating Sportsbook'
          this.triggerUpdateSportsBook()
        }
      }
    },

    publishChanges () {
      this.creation_mode = 'publish'
      if (this.validateForm()) {
        if (this.mode === 'create') {
          this.loading_message = 'Publishing Sportsbook'
          this.sportsbook_data.publish_status = 'published'
          this.triggerCreateSportsBook()
        } else if (this.mode === 'update') {
          this.loading_message = 'Updating Sportsbook'
          this.triggerUpdateSportsBook()
        }
      }
    },

    async onDuplicateBook () {
      await this.triggerDuplicateSportsBook()
    },

    async triggerDuplicateSportsBook () {
      this.loading = true
      this.loading_message = 'Duplicating SportsBook'
      let params = { id: this.selected_book_data.id }

      await this.duplicateSportsBook(params)

      this.showSnackbar(this.requestMsg)
      this.loading = false
      this.resetData()
    },

    async triggerUpdateSportsBook () {
      let data = this.sportsbook_data
      let formData = new FormData()

      formData.append('name', data.name)
      formData.append('content_description', data.content_description)
      formData.append('cta_btn_text', data.cta_btn_text)
      formData.append('disclaimer_text', data.disclaimer_text)
      formData.append('image_alt_text', data.image_alt_text)
      formData.append('content_title', data.content_title)

      if (data.website_url) formData.append('website_url', data.website_url)
      if (data.bethub_code) formData.append('bethub_code', data.bethub_code)
      if (data.slug) formData.append('slug', data.slug)

      formData.append('why_description', data.why_description)

      data.why_checklist.map(checklist => {
        formData.append('why_checklist[]', checklist)
      })

      if (this.color) formData.append('hex_color', this.color)

      if (this.creation_mode === 'publish') {
        formData.append('publish_status', data.publish_status)
      }

      if (data.cta_title) formData.append('cta_title', data.cta_title)

      data.cta_bonuses.map(bonus => {
        formData.append('cta_bonuses[]', bonus)
      })

      if (data.cta_url) formData.append('cta_url', data.cta_url)

      this.state_ids.map((state, i) => {
        formData.append(`states[${i}][us_states_id]`, state)
      })

      // if (data.promos) {
      //   data.promos.map((promo, i) => {
      //     formData.append(`promos[${i}][header]`, promo.header)
      //     formData.append(`promos[${i}][sub_header]`, promo.sub_header)
      //     formData.append(`promos[${i}][id]`, promo.id)
      //     if (promo.affiliate_link) formData.append(`promos[${i}][affiliate_link]`, promo.affiliate_link)
      //     formData.append(`promos[${i}][best_promo_flag]`, promo.best_promo_flag)
      //     formData.append(`promos[${i}][welcome_promo_flag]`, promo.welcome_promo_flag)
      //     if (promo.best_promo_position) formData.append(`promos[${i}][best_promo_position]`, promo.best_promo_position)
      //     if (promo.welcome_promo_position) formData.append(`promos[${i}][welcome_promo_position]`, promo.welcome_promo_position)
      //     if (promo.match_id) formData.append(`promos[${i}][match_id]`, promo.match_id)
      //   })
      // }
      if (data.faqs) {
        data.faqs.map((faq, i) => {
          formData.append(`faqs[${i}][question]`, faq.question)
          formData.append(`faqs[${i}][answer]`, faq.answer)
        })
      }

      if (data.review_author_name) {
        formData.append('review_author_name', data.review_author_name)
        formData.append('review_description', data.review_description)
        formData.append('review_rating', data.review_rating)
        if (!data.review_schema_name) data.review_schema_name = data.name
        if (!data.review_schema_review) data.review_schema_review = data.review_rating
        if (!data.review_schema_description) data.review_schema_description = data.content_description

        formData.append('review_schema_name', get(data, 'review_schema_name', data.name))
        formData.append('review_schema_review', get(data, 'review_schema_review', data.review_rating))
        formData.append('review_schema_description', get(data, 'review_schema_description', data.content_description))
        data.review_pros.map(pros => {
          formData.append('review_pros[]', pros)
        })
        data.review_cons.map(cons => {
          formData.append('review_cons[]', cons)
        })
        formData.append('review_publish_status', data.review_publish_status)
      }
      if (this.services_sports) {
        this.services_sports.map((sport, i) => {
          formData.append(`services[0][category]`, 'Sports')
          formData.append(`services[0][category_details][${i}]`, sport.category_details)
        })
      }

      if (this.deposit_options) {
        this.deposit_options.map((deposit, i) => {
          formData.append(`services[1][category]`, 'Deposit')
          formData.append(`services[1][category_details][${i}]`, deposit.category_details)
        })
      }

      if (this.withdrawal_options) {
        this.withdrawal_options.map((wdraw, i) => {
          formData.append(`services[2][category]`, 'Withdrawal Options')
          formData.append(`services[2][category_details][${i}]`, wdraw.category_details)
        })
      }

      if (data.title_meta) formData.append('title_meta', data.title_meta)
      if (data.description_meta) formData.append('description_meta', data.description_meta)
      formData.append('id', this.selected_book_data.id)
      formData.append('_method', 'put')

      await this.updateSportBook(formData)

      this.showSnackbar(this.requestMsg)

      this.loading_message = 'loading'
      this.loading = false

      if (this.mode === 'update' && this.creation_mode === 'publish') {
        if (data.publish_status === 'published') {
          data.publish_status = 'draft'
          this.publish_btn_txt = 'UnPublish'
        } else {
          data.publish_status = 'published'
          this.publish_btn_txt = 'Publish'
        }
      }

      if (data.logo) {
        this.loading = true
        this.loading_message = 'Updating SportBook Logo'
        let logoFormData = new FormData()
        logoFormData.append('id', this.selected_book_data.id)
        logoFormData.append('logo', data.logo)

        this.$refs.file.value = null
        await this.updateBookLogo(logoFormData)
        this.showSnackbar(this.requestMsg)
        this.loading = false
      }

      if (data.banner_logo) {
        this.loading = true
        this.loading_message = 'Updating SportBook Banner Image'
        let bannerFormData = new FormData()
        bannerFormData.append('id', this.selected_book_data.id)
        bannerFormData.append('banner_logo', data.banner_logo)

        this.$refs.bannerLogo.value = null
        await this.updateBookBanner(bannerFormData)
        this.showSnackbar(this.requestMsg)
        this.loading = false
      }

      if (data.welcome_logo) {
        this.loading = true
        this.loading_message = 'Updating SportBook Welcome Image'
        let welcomeFormData = new FormData()
        welcomeFormData.append('id', this.selected_book_data.id)
        welcomeFormData.append('welcome_logo', data.welcome_logo)

        this.$refs.welcomeLogo.value = null
        await this.updateBookWelcomeImage(welcomeFormData)
        this.showSnackbar(this.requestMsg)
        this.loading = false
      }

      if (data.small_logo) {
        this.loading = true
        this.loading_message = 'Updating SportBook Small Logo'
        let smallLogoFormData = new FormData()
        smallLogoFormData.append('id', this.selected_book_data.id)
        smallLogoFormData.append('small_logo', data.small_logo)

        this.$refs.xsmallLogo.value = null
        await this.updateSmallLogo(smallLogoFormData)
        this.showSnackbar(this.requestMsg)
        this.loading = false
      }

      if (data.welcome_promo_logo) {
        this.loading = true
        this.loading_message = 'Updating Welcome Promo Logo'
        let welcomePromoLogoFormData = new FormData()
        welcomePromoLogoFormData.append('id', this.selected_book_data.id)
        welcomePromoLogoFormData.append('welcome_promo_logo', data.welcome_promo_logo)

        this.$refs.welcomePromoLogo.value = null
        await this.updateWelcomePromoLogo(welcomePromoLogoFormData)
        this.showSnackbar(this.requestMsg)
        this.loading = false
      }

      if (data.review_author_name && data.review_avatar) {
        this.loading = true
        this.loading_message = 'Updating Review Author Image'
        let avatarFormData = new FormData()
        avatarFormData.append('id', this.selected_book_data.id)
        avatarFormData.append('review_avatar', data.review_avatar)

        this.$refs.authorAvatar.value = null
        await this.updateReviewAvatar(avatarFormData)
        this.showSnackbar(this.requestMsg)
        this.loading = false
      }

      if (data.image_meta) {
        this.loading = true
        this.loading_message = 'Updating Image Meta'
        let imageMetaFormData = new FormData()
        imageMetaFormData.append('id', this.selected_book_data.id)
        imageMetaFormData.append('image_meta', data.image_meta)

        this.$refs.imageMeta.value = null
        await this.updateImageMeta(imageMetaFormData)
        this.showSnackbar(this.requestMsg)
        this.loading = false
      }

      if (data.banner_logo) this.refreshList()
      this.fetchSportsBookList()
    },

    async triggerCreateSportsBook () {
      let data = this.sportsbook_data
      let formData = new FormData()

      formData.append('name', data.name)
      formData.append('content_description', data.content_description)
      formData.append('cta_btn_text', data.cta_btn_text)
      formData.append('disclaimer_text', data.disclaimer_text)
      formData.append('image_alt_text', data.image_alt_text)
      formData.append('content_title', data.content_title)

      if (data.website_url) formData.append('website_url', data.website_url)
      if (data.slug) formData.append('slug', data.slug)
      if (data.bethub_code) formData.append('bethub_code', data.bethub_code)
      formData.append('why_description', data.why_description)
      data.why_checklist.map(checklist => {
        formData.append('why_checklist[]', checklist)
      })
      if (this.color) formData.append('hex_color', this.color)
      formData.append('publish_status', data.publish_status)
      if (data.cta_title) formData.append('cta_title', data.cta_title)
      data.cta_bonuses.map(bonus => {
        formData.append('cta_bonuses[]', bonus)
      })
      if (data.cta_url) formData.append('cta_url', data.cta_url)
      if (data.logo) formData.append('logo', data.logo)
      if (data.banner_logo) formData.append('banner_logo', data.banner_logo)
      if (data.welcome_logo) formData.append('welcome_logo', data.welcome_logo)
      if (data.small_logo) formData.append('small_logo', data.small_logo)
      if (data.welcome_promo_logo) formData.append('welcome_promo_logo', data.welcome_promo_logo)
      this.state_ids.map((state, i) => {
        formData.append(`states[${i}][us_states_id]`, state)
      })
      // if (data.promos) {
      //   data.promos.map((promo, i) => {
      //     formData.append(`promos[${i}][header]`, promo.header)
      //     formData.append(`promos[${i}][sub_header]`, promo.sub_header)
      //     if (promo.match_id) formData.append(`promos[${i}][match_id]`, promo.match_id)
      //     if (promo.affiliate_link) formData.append(`promos[${i}][affiliate_link]`, promo.affiliate_link)
      //     formData.append(`promos[${i}][best_promo_flag]`, promo.best_promo_flag)
      //     formData.append(`promos[${i}][welcome_promo_flag]`, promo.welcome_promo_flag)
      //     if (promo.best_promo_position) formData.append(`promos[${i}][best_promo_position]`, promo.best_promo_position)
      //     if (promo.welcome_promo_position) formData.append(`promos[${i}][welcome_promo_position]`, promo.welcome_promo_position)
      //   })
      // }
      if (data.faqs) {
        data.faqs.map((faq, i) => {
          formData.append(`faqs[${i}][question]`, faq.question)
          formData.append(`faqs[${i}][answer]`, faq.answer)
        })
      }

      if (data.review_author_name) {
        formData.append('review_author_name', data.review_author_name)
        formData.append('review_description', data.review_description)
        formData.append('review_rating', data.review_rating)
        formData.append('review_schema_name', data.review_schema_name)
        formData.append('review_schema_review', data.review_schema_review)
        formData.append('review_schema_description', data.review_schema_description)
        data.review_pros.map(pros => {
          formData.append('review_pros[]', pros)
        })
        data.review_cons.map(cons => {
          formData.append('review_cons[]', cons)
        })
        formData.append('review_publish_status', data.review_publish_status)
        formData.append('review_avatar', data.review_avatar)
      }
      // if (data.services) {
      //   data.services.map((service, i) => {
      //     formData.append(`services[${i}][category]`, service.category)
      //     formData.append(`services[${i}][category_details]`, service.category_details)
      //   })
      // }

      if (this.services_sports) {
        this.services_sports.map((sport, i) => {
          formData.append(`services[0][category]`, 'Sports')
          formData.append(`services[0][category_details][${i}]`, sport.category_details)
        })
      }

      if (this.deposit_options) {
        this.deposit_options.map((deposit, i) => {
          formData.append(`services[1][category]`, 'Deposit')
          formData.append(`services[1][category_details][${i}]`, deposit.category_details)
        })
      }

      if (this.withdrawal_options) {
        this.withdrawal_options.map((wdraw, i) => {
          formData.append(`services[2][category]`, 'Withdrawal Options')
          formData.append(`services[2][category_details][${i}]`, wdraw.category_details)
        })
      }

      if (data.image_meta) {
        formData.append('image_meta', data.image_meta)
      }
      if (data.title_meta) formData.append('title_meta', data.title_meta)
      if (data.description_meta) formData.append('description_meta', data.description_meta)

      await this.createSportBook(formData)

      this.showSnackbar(this.requestMsg)
      this.loading_message = 'loading'
      this.loading = false

      this.fetchSportsBookList()
      if (this.requestStatus === 'success') {
        this.resetData()
      }
    },

    clearStateIds () {
      this.state_ids = []
    },

    showSnackbar (message) {
      this.snackbar.color = this.requestStatus
      this.snackbar.message = message
      this.snackbar.show = true
    },

    clearStateFilter () {
      this.location_filter = ''
    },

    async getBookData (id, i) {
      this.resetData()
      this.activeIndex = i
      this.mode = 'update'
      this.loading = true
      this.loading_message = 'Fetching Book Data'
      let params = { id: id }
      await this.getBookMaker(params)
        .then(response => {
          this.selected_book_data = response.data

          this.loading = false

          this.mode = 'update'
        }).then(res => {
          this.selectBook()
        })
        .catch(err => {
          console.log(err)
        })
    },

    selectBook () {
      let bookDetails = this.selected_book_data

      if (bookDetails.publish_status === 'published' && this.mode === 'update' && this.creation_mode === 'publish') {
        this.sportsbook_data.publish_status = 'draft'
        this.publish_btn_txt = 'UnPublish'
      } else {
        if (bookDetails.publish_status === 'draft') {
          this.sportsbook_data.publish_status = 'published'
          this.publish_btn_txt = 'Publish'
        } else {
          this.sportsbook_data.publish_status = 'draft'
          this.publish_btn_txt = 'UnPublish'
        }
      }
      this.selected_book_id = bookDetails.id
      this.sportsbook_data.name = bookDetails.name
      this.sportsbook_data.slug = bookDetails.slug
      this.sportsbook_data.content_description = bookDetails.content_description
      this.sportsbook_data.content_title = bookDetails.content_title
      this.sportsbook_data.bethub_code = bookDetails.bethub_code
      if (bookDetails.why_checklist) this.sportsbook_data.why_checklist = bookDetails.why_checklist
      this.sportsbook_data.website_url = bookDetails.website_url
      this.sportsbook_data.why_description = bookDetails.why_description
      this.sportsbook_data.hex_color = bookDetails.hex_color
      this.color = bookDetails.hex_color
      this.sportsbook_data.cta_title = bookDetails.cta_title
      this.sportsbook_data.cta_bonuses = []
      this.sportsbook_data.cta_btn_text = bookDetails.cta_btn_text
      this.sportsbook_data.disclaimer_text = bookDetails.disclaimer_text
      this.sportsbook_data.image_alt_text = bookDetails.logo.custom_properties.alt_text

      if (bookDetails.cta_bonuses) this.sportsbook_data.cta_bonuses = bookDetails.cta_bonuses
      this.sportsbook_data.promos = []
      if (bookDetails.promos) {
        bookDetails.promos.map((promo, i) => {
          this.sportsbook_data.promos.push({
            header: promo.header,
            sub_header: promo.sub_header,
            affiliate_link: promo.affiliate_link,
            best_promo_flag: promo.best_promo_flag,
            welcome_promo_flag: promo.welcome_promo_flag,
            best_promo_position: promo.best_promo_position ? parseInt(promo.best_promo_position, 10) : '',
            welcome_promo_position: promo.welcome_promo_position ? parseInt(promo.welcome_promo_position, 10) : '',
            id: promo.id,
            match_id: promo.match_id
          })
        })
      }
      this.sportsbook_data.cta_url = bookDetails.cta_url
      this.state_ids = []
      if (bookDetails.states) {
        bookDetails.states.map((state, i) => {
          this.state_ids.push(state.id)
        })
      }

      if (bookDetails.banner_logo) this.banner_logo_preview_url = bookDetails.banner_logo.url
      if (bookDetails.logo) this.logo_preview_url = bookDetails.logo.url
      if (bookDetails.welcome_logo) this.welcome_logo_preview_url = bookDetails.welcome_logo.url
      if (bookDetails.small_logo) this.small_logo_preview_url = bookDetails.small_logo.url
      if (bookDetails.welcome_promo_logo) this.welcome_promo_logo_preview_url = bookDetails.welcome_promo_logo.url

      if (bookDetails.image_meta) {
        this.image_meta_preview_url = bookDetails.image_meta.thumb_url
      }

      this.sportsbook_data.title_meta = bookDetails.title_meta
      this.sportsbook_data.description_meta = bookDetails.description_meta

      this.sportsbook_data.review_pros = []
      this.sportsbook_data.review_cons = []
      this.sportsbook_data.review_author_name = ''
      this.sportsbook_data.review_publish_status = bookDetails.review_publish_status
      this.sportsbook_data.review_rating = ''
      this.sportsbook_data.review_description = ''
      if (bookDetails.review) {
        this.sportsbook_data.review_author_name = bookDetails.review.author_name
        this.sportsbook_data.review_publish_status = bookDetails.review.publish_status
        this.sportsbook_data.review_rating = bookDetails.review.rating
        this.sportsbook_data.review_description = bookDetails.review.review_description
        this.sportsbook_data.review_pros = bookDetails.review.pros
        this.sportsbook_data.review_cons = bookDetails.review.cons
        this.sportsbook_data.review_schema_name = bookDetails.review.schema_name
        this.sportsbook_data.review_schema_review = bookDetails.review.schema_review
        this.sportsbook_data.review_schema_description = bookDetails.review.schema_description
      }

      if (bookDetails.review) this.review_author_avatar_preview = bookDetails.review.review_avatar.url

      if (bookDetails.services) {
        bookDetails.services.map((service, i) => {
          if (service.category === 'Sports') {
            service.category_details.map((sport, i) => {
              this.services_sports.push({
                category: 'Sport',
                category_details: sport
              })
            })
          } else if (service.category === 'Deposit') {
            service.category_details.map((deposit, i) => {
              this.deposit_options.push({
                category: 'Deposit',
                category_details: deposit
              })
            })
          } else if (service.category === 'Withdrawal Options') {
            service.category_details.map((wdraw, i) => {
              this.withdrawal_options.push({
                category: 'Withdrawal Options',
                category_details: wdraw
              })
            })
          }
        })
      }
      this.sportsbook_data.faqs = []
      if (bookDetails.faqs) {
        bookDetails.faqs.map((faq, i) => {
          this.sportsbook_data.faqs.push({
            question: faq.question,
            answer: faq.answer
          })
        })
      }
    },

    async loadMore () {
      this.loadingMore = true

      if (this.listMeta.current_page < this.listMeta.last_page) {
        let params = { page: this.listMeta.current_page + 1 }
        params.sort = '-created_at'

        await this.getBookList(params)
      }
      this.loadingMore = false
    },

    resetData () {
      this.mode = 'create'
      this.sportsbook_data.slug = ''
      this.sportsbook_data.cta_bonuses = []
      this.sportsbook_data.promos = []
      this.sportsbook_data.name = ''
      this.sportsbook_data.content_description = ''
      this.sportsbook_data.website_url = ''
      this.sportsbook_data.bethub_code = ''
      this.sportsbook_data.states = []
      this.sportsbook_data.why_description = ''
      this.sportsbook_data.why_checklist = []
      this.sportsbook_data.hex_color = ''
      this.sportsbook_data.promos = []
      this.sportsbook_data.review_author_name = ''
      this.sportsbook_data.review_description = ''
      this.sportsbook_data.review_rating = ''
      this.sportsbook_data.review_pros = []
      this.sportsbook_data.review_cons = []
      this.sportsbook_data.review_publish_status = 'draft'
      this.sportsbook_data.review_avatar = null
      this.sportsbook_data.services = []
      this.sportsbook_data.faqs = []
      this.sportsbook_data.logo = null
      this.sportsbook_data.small_logo = null
      this.sportsbook_data.welcome_promo_logo = null
      this.sportsbook_data.banner_logo = null
      this.sportsbook_data.welcome_logo = null
      this.sportsbook_data.publish_status = 'draft'
      this.sportsbook_data.cta_title = ''
      this.sportsbook_data.cta_bonuses = []
      this.sportsbook_data.cta_url = ''
      this.sportsbook_data.cta_btn_text = ''
      this.sportsbook_data.disclaimer_text = ''
      this.sportsbook_data.description_meta = ''
      this.sportsbook_data.title_meta = ''
      this.sportsbook_data.review_schema_name = ''
      this.sportsbook_data.review_schema_review = ''
      this.sportsbook_data.review_schema_description = ''
      this.sportsbook_data.content_title = ''
      this.state_ids = []
      this.logo_preview_url = ''
      this.banner_logo_preview_url = ''
      this.small_logo_preview_url = ''
      this.welcome_promo_logo_preview_url = ''
      this.welcome_logo_preview_url = ''
      this.image_meta_preview_url = ''
      this.review_author_avatar_preview = ''
      this.services_sports = []
      this.deposit_options = []
      this.withdrawal_options = []
      this.$refs.file.value = null
      this.$refs.bannerLogo.value = null
      this.$refs.welcomeLogo.value = null
      this.$refs.authorAvatar.value = null
      this.$refs.xsmallLogo.value = null
      this.publish_btn_txt = 'Publish'
      this.hex = '#FFFFFF'
      this.sportsbook_data.image_meta = null
      this.$refs.imageMeta.value = null
      this.sportsbook_data.image_alt_text = ''
    },

    async triggerDeleteSportsBook () {
      this.confirmDeleteDialog = false
      this.loading = true
      this.loading_message = 'Deleting SportsBook'
      let params = { id: this.selected_book_data.id }

      await this.deleteSportsBook(params)

      this.showSnackbar(this.requestMsg)
      this.loading_message = 'Fetching SportsBooks'
      this.loading = false

      this.sportsBooksList.splice(this.activeIndex, 1)
      this.activeIndex = null
      this.resetData()
    },

    async triggerGenerateSlug () {
      this.generatingSlug = true
      let params = { title: this.sportsbook_data.name }

      await this.generateSlug(params)
        .then(response => {
          this.sportsbook_data.slug = response.data.slug
        }).catch(err => {
          console.log(err)
        })

      this.generatingSlug = false
    },

    previewBook () {
      if (this.selected_book_data.states) {
        window.open(process.env.VUE_APP_WEB_URL + `/best-books/${this.selected_book_data.states[0].name}/${this.selected_book_data.slug}`, '_blank')
      }
    },

    filterByState () {
      if (this.states_filter_id) {
        let location = find(this.states_option, ['value', this.states_filter_id])
        this.location_filter = location.text
        this.loading_message = `Fetching Sportsbooks for ${this.location_filter}`
      } else {
        this.location_filter = ''
        this.loading_message = `Fetching Sportsbooks`
      }
      this.filterSportBooks()
    },

    async filterSportBooks (page = 1) {
      let params = { page }
      this.loading = true

      params.sort = '-created_at'
      params.location = this.location_filter
      this.resetData()
      this.refreshList()
      await this.getBookList(params)
      this.loading = false
      this.loading_message = `Fetching Sportsbooks`
    }

  },

  created () {
    this.fetchUSStates()
    this.fetchSportsBookList()
  },

  watch: {
    validation_dialog (val) {
      if (val === false) {
        this.clearValidationErrors()
      }
    }
  },

  mounted () {
    if (this.sportsbook_data.services) {
      this.services_sports = this.sportsbook_data.services.filter(function (service) {
        if (service.category === 'Sports') return service
      })

      this.deposit_options = this.sportsbook_data.services.filter(function (service) {
        if (service.category === 'Deposit') return service
      })

      this.withdrawal_options = this.sportsbook_data.services.filter(function (service) {
        if (service.category === 'Withdrawal Options') return service
      })
    }
  }

}
</script>

<style>
.custom.v-text-field > .v-input__control > .v-input__slot:before {
  border-style: none;
}
.custom.v-text-field > .v-input__control > .v-input__slot:after {
  border-style: none;
}
</style>

<style scoped>
.header-btns {
  color: #df4661;
  cursor: pointer;
}
.delete-sportbook {
  cursor: pointer;
}
.publish-btn {
  font-size: 9px !important;
}
.border-right {
  border-right: 1px solid #c5c6c7;
}
.sportsbook-row {
  border-top: 1px solid #c5c6c7;
  min-height: 1000px;
}
#sportsbook-container {
  margin-top: 10px;
}
.sportsbook-logo {
  width: 100%;
  height: 175px;
}
.sportsbook-logo-small {
  width: 100%;
  height: 45px;
}
.upload-btn {
  border: 1px solid #df4661;
  color: #df4661;
  background-color: white !important;
  margin-top: 10px;
}
.upload-btn:hover {
  color: white;
  background-color: #df4661 !important;
}
.section-headers {
  font-size: 24px;
  font-weight: bold;
}
.remove-reason {
  cursor: pointer;
}
.pros {
  color: green;
}
.cons {
  color: red;
}
.withdrawal-options {
  margin-top: 20px;
}
.why-join-error-container > .v-input__control > .v-input__slot:after {
  border-style: none;
}
.why-join-error-container > .v-input__control > .v-input__slot:before {
  border-style: none;
}
.booklist-row {
  border-bottom: 1px solid #c5c6c7;
}
.booklist-row:hover {
  cursor: pointer;
  background: #eaf5ff;
}
.selected-item {
  background-color: #eaf5ff;
}
.infinite-loading-row {
  height: 800px;
  max-height: 1000px;
  overflow: scroll;
  overflow-x: hidden;
  padding-bottom: 200px;
}
/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.add-book-btn {
  position: absolute;
  margin-bottom: 1px;
}
.confirm-delete {
  word-break: initial;
}
.book-image {
  padding-left: 100px;
  padding-right: 0;
}
</style>
